$(document).foundation();
if ($(window).width() > 767) {
    jQuery(function(){
        var lastScrollTop = 0;
            jQuery(document).scroll(function(event){
            var st = $(this).scrollTop();
            if(st > (125)){
                if (st > lastScrollTop){
                    $(".header__top").addClass("header-fix");
                    $(".header__top").removeClass("top__logo__show");
               }
               else{
                    $(".header__top").removeClass("header-fix");
                    $(".header__top").addClass("top__logo__show");
               }
            }
            else if(st < (1)){
                $(".header__top").removeClass("header-fix");
                $(".header__top").removeClass("top__logo__show");
            }
            lastScrollTop = st;
        });
    });
}

$(function () {
    $('.content__subpage a').click(function() {
        var $this = $(this);
        var href = $this.attr('href');

        console.log(href);
        if(href.startsWith('#')) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(href).offset().top
            }, 2000);
            return false;
        }
    });


    handleFavorites();

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $('.content__subpage h1').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });

    $('.camps__book h1').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });

    $('.camps__intro h1').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });

    $('.camps__detail__intro h1').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });


    $('.camps__favorites h2').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });

    $('.h1-title').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if(index == -1) {
            index = word.length;
        }
        $(this).html('<span class="firstword">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });

    // $(".content__subpage h1").firstword();
    // $(".camps__intro h1").firstword();
    // $(".camps__detail__intro h1").firstword();
    // $(".camps__book h1").firstword();
    // $(".camps__favorites h2").firstword();
    // $(".camps__more__info h2").firstword();


    // $(".h1-title").each(function() {
    //     $(this).firstword();
    // });

    jQuery(".camps__intro__text .btn--informatie").click(function(){
        jQuery('html,body').animate({
           scrollTop: jQuery(".content__subpage").offset().top-30
        }, 800);
    });

    $(function() {
        $('.match-height').matchHeight();
    });

    $('.content__image--right').each(function() {
        var imgSrc = $(this).attr('src');
        $(this).parent().css({'background-image': 'url('+imgSrc+')'});
        $(this).remove();
    });

    $('.footer--fixed').each(function() {
        footerHeight = $("footer").height();
        $(".footer--fixed .main").css({'margin-bottom': footerHeight});
    });

    $(document).ready(function() {
        $("a").each(function(i) {
            let id = $(this).attr('id');
            if(!id || id.length === 0) {
                $(this).attr('id', ("go-a-" + (i + 1)));
            }
        });
    });

    $(document).ready(function() {
        $("button").each(function(i) {
            $(this).attr('id', ("go-button-" + (i+1)));
        });
    });

    jQuery(document).ready(function() {
        jQuery('.timeline-item:even').addClass("").viewportChecker({
            classToAdd: 'timeline-animation animated bounceInLeft',
            offset: 240
        });
        jQuery('.timeline-item:odd').addClass("").viewportChecker({
            classToAdd: 'timeline-animation animated bounceInRight',
            offset: 240
        });
    });

    $(".faq__item__btn").click(function () {
        $(this).parent().find('.faq__item__answer').toggleClass("faq__item__answer--open");
        $(this).toggleClass("faq__item__btn--open");
    });

    $(".camps__overview__item__favorite").click(function () {
        $(this).toggleClass("camps__overview__item__favorite__active");
    });

    $(".checkbox__text__extra__info__btn").click(function () {
        $(this).parent().find('.extra__tooltip').toggleClass("extra__tooltip--open");
    });

    $(".extra__tooltip__close").click(function () {
        $(this).parent().toggleClass("extra__tooltip--open");
    });

    $('.tabs-mobile-title').click(function(){
        $(this).parent().toggleClass('tabs-mobile-open');
    });

    $(".btn--filter").click(function () {
        $(this).parent().find('form').toggleClass("form--active");
    });

    $('.theiaStickySidebar').theiaStickySidebar({
        additionalMarginTop: 180
    });

    $(".fdatepicker").fdatepicker({
        language: 'nl',
        format: 'dd-mm-yyyy'
    });

    $(".disable-scroll").click(function () {
        $('.disable-scroll').fadeOut();
    });

    $(".language__selector__current").click(function () {
        $('.language__selector__all').fadeToggle();
        $(".language__selector__current").toggleClass("language__selector__current__open");
    });

    // hide #back-top first
    $("#back-totop").hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('#back-totop').fadeIn();
        } else {
            $('#back-totop').fadeOut();
        }
    });

    // scroll body to 0px on click
    $('#back-totop').click(function () {
        $('body,html').animate({scrollTop: 0}, 800);
        return false;
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
        var e = document.getElementsByClassName("phone");
        for (i = 0; i < e.length; i++)
        e[i].setAttribute("x-ms-format-detection", "none");
    }

    $('.fancybox').fancybox({
        beforeLoad: function (data) {
            $('.debugmsgs').remove();
        },
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    $('.content-fancybox-gallery .fancybox').each(function () {
        $(this).attr('data-fancybox-group', 'data-fancybox-group');
    });

    $('.fancybox-ajax').fancybox({
        type: 'ajax',
        beforeLoad: function (data) {
            $('.debugmsgs').remove();
        },
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    $('.fancybox-iframe2').fancybox({
        'type': 'iframe',
        'titleShow': false,
        'transitionIn': 'elastic',
        'transitionOut': 'elastic',
        'padding': 0,
        'maxWidth': 800,
        'maxHeight': 450,
        'fitToView': true,
        'autoScale': true,
        helpers: {
            overlay: {
                locked: false
            }
        }
    });


    ajaxFilter();

    // popup warning
    $(".warning__close").click(function () {
        $(".warning").css("display","none");
    });
});

function ajaxFilter()
{
    $('.ajax-filter').each(function(){
        var form = $(this);
        form.append('<input type="hidden" name="action" value="Filter" />');
        form.append('<input type="hidden" name="koppel" value="' + form.attr('data-koppel') + '" />');
        $(this).find(':input[type="checkbox"]').change(function(){
            $.fancybox.showLoading();
            $.ajax({
                url: window.location.href,
                data: form.serialize(),
                type: 'post',
                success: function(data)
                {
                    $('.ajax-filter').replaceWith(data);
                    new Foundation.Accordion($('.accordion'));
                    $.fancybox.hideLoading();
                    ajaxFilter();
                }
            });
        })
    });
}

$(document).ready(function() {
    $('.reference__slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        swipeToSlide: true,
        variableWidth: true,
        responsive: [
        {
        breakpoint: 1240,
            settings: {
                slidesToShow: 4
            }
        }
      ]
    });
});

$(document).ready(function() {
    $('.camp__slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1160,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 870,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
    });
});


(function ( $ ) {
    $.fn.alterClass = function ( removals, additions ) {
        var self = this;
        if ( removals.indexOf( '*' ) === -1 ) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass( removals );
            return !additions ? self : self.addClass( additions );
        }

        var patt = new RegExp( '\\s' +
            removals.
            replace( /\*/g, '[A-Za-z0-9-_]+' ).
            split( ' ' ).
            join( '\\s|\\s' ) +
            '\\s', 'g' );

        self.each( function ( i, it ) {
            var cn = ' ' + it.className + ' ';
            while ( patt.test( cn ) ) {
                cn = cn.replace( patt, ' ' );
            }
            it.className = $.trim( cn );
        });

        return !additions ? self : self.addClass( additions );
    };
})(jQuery);


function handleFavorites() {
    var favorites = readCookie('favorites');
    favorites = JSON.parse(favorites);

    if (favorites){
        $('.js-favorite').each(function() {
            var id = parseInt($(this).data('id'));
            if (favorites.indexOf(id) !== -1) {
                $(this).addClass('camps__overview__item__favorite__active camps__detail__intro__favorite--active');
            }
        });
    }



    $('.js-favorite').click(function() {
        var id = parseInt($(this).data('id'));
        var favorites = readCookie('favorites')
        favorites = JSON.parse(favorites);
        if(favorites == undefined) {
            favorites = [];
        }
        if(favorites.indexOf(id) !== -1) {
            var index = favorites.indexOf(id);
            favorites.splice(index, 1);
            $(this).removeClass('camps__overview__item__favorite__active camps__detail__intro__favorite--active');
        }else {
            favorites.push(id);
            $(this).addClass('camps__overview__item__favorite__active camps__detail__intro__favorite--active');
        }

        favorites = JSON.stringify(favorites);
        createCookie('favorites', favorites, 1000);
        return false;
    });
}


function createCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}
